import { render } from "./LinkPurchaseModal.vue?vue&type=template&id=67214512&scoped=true"
import script from "./LinkPurchaseModal.vue?vue&type=script&lang=js"
export * from "./LinkPurchaseModal.vue?vue&type=script&lang=js"

import "./LinkPurchaseModal.vue?vue&type=style&index=0&id=67214512&lang=stylus&scoped=true"
import "./LinkPurchaseModal.vue?vue&type=style&index=1&id=67214512&lang=stylus"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67214512"]])

export default __exports__